import { Time } from "@angular/common";
import { IInduccionModel, IInduccionProgramarModel, IInduccionReprogramarModel } from "../interfaces/induccion/IInduccionModel";

export class InduccionModel implements IInduccionModel {
    idInduccion: number;
    idEstado: number;
    estado: string;
    dni: string;
    nombres: string;
    apellidoPaterno: string;
    apellidoMaterno: string;
    fechaAprobacion: Date;
    fechaHoraInduccion: Date;
    comentarios: string;
    idSede: number;
    sede: string;
    idContratista: number;
    contratista: string;
    idSolicitud: number;
    codigoSolicitud: string;

    constructor(){
        this.idInduccion = 0;
        this.idEstado= 0;
        this.estado = '';
        this.dni = '';
        this.nombres = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.fechaAprobacion = new Date();
        this.fechaHoraInduccion = new Date();
        this.comentarios = '';
        this.idSede = 0;
        this.sede = '';
        this.idContratista = 0;
        this.contratista = '';
        this.idSolicitud = 0;
        this.codigoSolicitud = '';
    }
}

export class InduccionProgramarModel implements IInduccionProgramarModel {
    idInduccion: number;
    fechaInduccion: Date;
    comentarios: string;
    listaInducciones: number[];
    horaInduccion: string;
    
    constructor(){
        this.idInduccion = 0;
        this.fechaInduccion = new Date();
        this.comentarios = '';
        this.listaInducciones = new Array<number>();
        this.horaInduccion = '';
    }
}

export class InduccionReprogramarModel implements IInduccionReprogramarModel {
    fechaInduccion: Date;
    comentarios: string;
    listaInducciones: number[];
    horaInduccion: string;
    
    constructor(){
        this.fechaInduccion = new Date();
        this.horaInduccion = '';
        this.comentarios = '';
        this.listaInducciones = new Array<number>();
    }
}